import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { MODULOS_LISTA } from "@/lib/modulos";
import { userHasModuleAccess } from "@/lib/moduleAccess";

const MODULE_IDS = new Set(MODULOS_LISTA.map((m) => m.id));

export default function ModuleGuard({ moduleId, children }) {
  const { user, empresa } = useAuth();

  if (!moduleId || !MODULE_IDS.has(moduleId)) {
    return <>{children}</>;
  }

  if (!user) {
    return <>{children}</>;
  }

  const isAdmin = user.role === "admin";
  if (moduleId === "Empresas" && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (!userHasModuleAccess(user, empresa, moduleId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
